const preloadMFE = mfeId => {
  System.import(mfeId);
};

export default preloadMFE;
